export default __webpack_public_path__ + "static/media/640_portfolio03-es-web.c0e59383.png";